import { ThunkAction } from 'redux-thunk';

import { State } from 'app/gamma/src/modules';

export * from './products';
export * from './models';
export * from './responses';
export * from './experiment';

export type StandardThunkAction<R = Promise<void>, E = void> = ThunkAction<
  R,
  State,
  E
>;
